import React, { useState } from "react";
import { toast } from "sonner";

export default function ContactModal({ open, onClose }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [gotcha, setGotcha] = useState("");
  const [sending, setSending] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const r = await fetch("/api/forms/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          email,
          message,
          // Honeypot spam protection (hidden field)
          _gotcha: gotcha,
        }),
      });
      if (!r.ok) {
        const detail = await r
          .json()
          .then((j) => (typeof j?.detail === "string" ? j.detail : "Send failed"))
          .catch(() => "Send failed");
        throw new Error(detail);
      }
      toast.success("Sent!");
      setName("");
      setEmail("");
      setMessage("");
      setGotcha("");
      onClose();
    } catch (err) {
      toast.error(err?.message || "Send failed.");
    }
    setSending(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="contact-title">
      <button type="button" className="absolute inset-0 bg-black/40 backdrop-blur-[1px]" aria-label="Close dialog overlay" onClick={onClose} />
      <div className="relative z-[101] w-full max-w-narrow rounded-ds-2xl border border-border bg-surface p-6 shadow-modal">
        <div className="mb-4 flex items-start justify-between gap-4">
          <h2 id="contact-title" className="text-xl font-bold text-fg">
            Contact us
          </h2>
          <button type="button" onClick={onClose} className="rounded-ds p-1 text-fg-tertiary hover:bg-canvas-subtle focus:outline-none focus-visible:shadow-focus">
            ✕
          </button>
        </div>
        <form onSubmit={submit} className="flex flex-col gap-3">
          <label className="text-xs font-medium text-fg-secondary">
            Name
            <input required value={name} onChange={(e) => setName(e.target.value)} className="mt-1 w-full rounded-ds border border-border px-3 py-2 text-sm focus:outline-none focus-visible:shadow-focus" />
          </label>
          <label className="text-xs font-medium text-fg-secondary">
            Email
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-ds border border-border px-3 py-2 text-sm focus:outline-none focus-visible:shadow-focus" />
          </label>
          <label className="text-xs font-medium text-fg-secondary">
            Message
            <textarea required rows={4} value={message} onChange={(e) => setMessage(e.target.value)} className="mt-1 w-full resize-y rounded-ds border border-border px-3 py-2 text-sm focus:outline-none focus-visible:shadow-focus" />
          </label>
          <input
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            name="_gotcha"
            value={gotcha}
            onChange={(e) => setGotcha(e.target.value)}
            style={{ display: "none" }}
          />
          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={onClose} className="rounded-ds border border-border px-4 py-2 text-sm font-medium text-fg-secondary hover:bg-canvas-subtle">
              Cancel
            </button>
            <button type="submit" disabled={sending} className="rounded-ds bg-accent px-4 py-2 text-sm font-semibold text-white hover:bg-accent-hover focus:outline-none focus-visible:shadow-focus disabled:opacity-50">
              {sending ? "Sending…" : "Send"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
